export default __webpack_public_path__ + "fb2061d0dbd199e6af4a2e4c56e117bb.png";